'use client'
import React from 'react'
import { useTranslations } from 'next-intl'
import { Avatar, AvatarImage } from '@/registry/default/ui/avatar'

interface FeatureProps {
  config?: any
}

export function FeedBack({ config }: FeatureProps) {
  const t = useTranslations('home.feature')
  return (
    <div className="bg-blue-50 py-4">
      <div className="container flex flex-col gap-8 py-12 px-0 h-full text-foreground dark:text-background/90">
        <h6 className="text-base md:text-xl  text-blue-600 font-medium flex w-full h-full  ">
          为什么选择我们
        </h6>
        <h2 className="text-3xl md:text-3xl font-medium w-full h-full ">
          来自客户真实的反馈
        </h2>
        <h2 className="text-base md:text-sm w-full h-full">
          在拨业务日常调整频繁，一个新业务通常要经历十几次调整后才能趋于稳定，能够快捷的调整话术非常关键。我们提供
          AI
          电话员工话术维护功能，让你轻松应对业务调整，快速响应，实时变更，无培训与纠错成本在拨业务日常关键。我们提供
          AI
          电话员工话术维护功能，让你轻松应对业务调整，快速响应，实时变更，无培训与纠错成本。
        </h2>

        <div className="items-start mt-14 gap-4 md:justify-center w-full h-full md:grid lg:grid-cols-4 xl:grid-cols-4">
          <div className="p-4 rounded-md md:flex-col items-start space-y-4  flex flex-col h-full">
            <Avatar className={'w-12 h-12'}>
              <AvatarImage src="/home/feed-1.svg" />
            </Avatar>
            <h6 className="text-base md:text-md  font-medium flex w-full ">
              这是我用过最好的工具，非常好的解决了我们的问题，推荐给你们使用，不用再犹豫，立即下单吧，保证你不会后悔！
            </h6>
            <div className={'flex gap-3 items-center'}>
              <Avatar className={'w-14 h-14'}>
                <AvatarImage src="/home/user.svg" />
              </Avatar>
              <div className={'flex-col gap-2 flex'}>
                <h2 className="text-sm flex w-full font-medium ">胡老师</h2>
                <h2 className="text-xs flex w-full  ">
                  没心学校 / 北京校区校长
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4   rounded-md md:flex-col items-start space-y-4  flex flex-col h-full">
            <Avatar className={'w-12 h-12'}>
              <AvatarImage src="/home/feed-2.svg" />
            </Avatar>
            <h6 className="text-base md:text-md   font-medium flex w-full ">
              这是我用过最好的工具，非常好的解决了我们的问题，推荐给你们使用，不用再犹豫，立即下单吧，保证你不会后悔！
            </h6>
            <div className={'flex gap-3 items-center'}>
              <Avatar className={'w-14 h-14'}>
                <AvatarImage src="/home/user.svg" />
              </Avatar>
              <div className={'flex-col gap-2 flex'}>
                <h2 className="text-sm flex w-full font-medium ">胡老师</h2>
                <h2 className="text-xs flex w-full  ">
                  没心学校 / 北京校区校长
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4   rounded-md md:flex-col items-start space-y-4  flex flex-col h-full">
            <Avatar className={'w-12 h-12'}>
              <AvatarImage src="/home/feed-3.svg" />
            </Avatar>
            <h6 className="text-base md:text-md   font-medium flex w-full ">
              这是我用过最好的工具，非常好的解决了我们的问题，推荐给你们使用，不用再犹豫，立即下单吧，保证你不会后悔！
            </h6>
            <div className={'flex gap-3 items-center'}>
              <Avatar className={'w-14 h-14'}>
                <AvatarImage src="/home/user.svg" />
              </Avatar>
              <div className={'flex-col gap-2 flex'}>
                <h2 className="text-sm flex w-full font-medium ">胡老师</h2>
                <h2 className="text-xs flex w-full  ">
                  没心学校 / 北京校区校长
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4  md:flex-col items-start space-y-4  flex flex-col h-full">
            <Avatar className={'w-12 h-12'}>
              <AvatarImage src="/home/feed-4.svg" />
            </Avatar>
            <h6 className="text-base md:text-md   font-medium flex w-full ">
              这是我用过最好的工具，非常好的解决了我们的问题，推荐给你们使用，不用再犹豫，立即下单吧，保证你不会后悔！
            </h6>
            <div className={'flex gap-3 items-center'}>
              <Avatar className={'w-14 h-14'}>
                <AvatarImage src="/home/user.svg" />
              </Avatar>
              <div className={'flex-col gap-2 flex'}>
                <h2 className="text-sm flex w-full font-medium ">胡老师</h2>
                <h2 className="text-xs flex w-full  ">
                  没心学校 / 北京校区校长
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
